export function timestampFormat(timestamp) {
  let curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  let timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数

  let curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  let tmDate = new Date(timestamp * 1000); // 参数时间戳转换成的日期对象

  let Y = tmDate.getFullYear(),
    m = tmDate.getMonth() + 1,
    d = tmDate.getDate();
  if (timestampDiff < 60) {
    // 一分钟以内
    return "1 minute";
  } else if (timestampDiff < 3600) {
    // 一小时前之内
    return Math.floor(timestampDiff / 60) + "min";
  } else if (
    curDate.getFullYear() == Y &&
    curDate.getMonth() + 1 == m &&
    curDate.getDate() == d
  ) {
    return Math.floor(timestampDiff / (60 * 60)) + "h";
  } else {
    if (curDate.getFullYear() == Y) {
      return Math.floor(timestampDiff / (60 * 60 * 24)) + "d";
    } else {
      return Math.floor(timestampDiff / (60 * 60 * 24 * 365)) + "Y";
    }
  }
}

//
//
//
//
//
//
//
